import React, { useContext, useMemo } from "react";
import {
    Link,
    Navigate,
    Outlet,
    Route,
    Routes,
    useLocation
} from "react-router-dom";
import AdminApp from "./AdminApp";
import StatisticsView from "./components/statistics/StatisticsView";
import ForgotPassword from "./components/authenticate/ForgotPassword";
import Login from "./components/authenticate/Login";
import ResetPassword from "./components/authenticate/ResetPassword";
import FullScreenWrapper from "./components/FullscreenWrapper";
import { AuthContext } from "./contexts/AuthContext";
import DeliveryConfiguration from "./pages/deliveryConfigurations/DeliveryConfigurations";
import AdminLandingpage from "./pages/landingpage/Landingpage";
import Materials from "./pages/materials/Materials";
import Modelpacks from "./pages/modelpacks/Modelpacks";
import Models from "./pages/models/Models";
import Modifiers from "./pages/modifiers/Modifiers";
import Scenes from "./pages/scenes/Scenes";
import AdminTemplates from "./pages/templates/Templates";
import Users from "./pages/users/Users";
import ErrorPage from "./pages/ErrorPage";
import ProjectsPage from "./pages/projects/Projects";
import ProjectPage from "./pages/projects/Project";
import Orders from "./pages/orders/Orders";
import Order from "./pages/orders/Order";
import AssetProjectPage from "./pages/assetProjects/AssetProject";
import AssetProjectsPage from "./pages/assetProjects/AssetProjects";
import Pages from "./pages/pages/Pages";
import BomModels from "./pages/bommodels/BomModels";
import OutputFormats from "./pages/outputFormats/OutputFormats";
import Client from "./pages/client/Client";
import UserGroups from "./pages/usergroups/UserGroups";
import UIAssetFilterGroups from "./pages/uiassetfiltergroups/UIAssetFilterGroups";
import UIAssetFilters from "./pages/uiassetfilters/UIAssetFilters";
import WhiteModels from "./pages/bommodels/WhiteModels";
import DAMTransfers from "./pages/damTransfers/DAMTransfers";
import TemplatePresets from "./pages/templatePresets/TemplatePresets";

const ProtectedRoute = () => {
    const { isLoggedIn } = useContext(AuthContext);
    const location = useLocation();

    if (!isLoggedIn) {
        return <Navigate to="/auth/login" replace state={{ from: location }} />
    }

    return (
        <Outlet />
    );
};

const AppRouter: React.FC = () => { 
    let routes = useMemo(() => {
    
        return (
            <Routes>
                <Route errorElement={<ErrorPage />}>
                    <Route path="/auth" element={<FullScreenWrapper />}>
                        <Route path="login" element={<Login />} />
                        <Route path="forgotpassword" element={<ForgotPassword />} />
                        <Route path="resetpassword" element={<ResetPassword />} />
                        <Route path="resetconfirmation" element={<><h1>Your password has been reset!</h1><Link to="/">Go to login</Link></>} />
                        <Route path="forgotconfirmation" element={<h1>You will receive an email shortly with a link to reset your password.</h1>} />
                    </Route>
                    <Route element={<ProtectedRoute />}>
                        <Route element={<AdminApp />}>
                            <Route index element={<AdminLandingpage />} />
                            <Route path="orders">
                                <Route index element={<Orders />} />
                                <Route path=":orderid" element={<Order />} />
                            </Route>
                            {/* <Route path="projects">
                                <Route index element={<ProjectsPage />} />
                                <Route path=":projectId" element={<ProjectPage />} />
                            </Route> */}
                            <Route path="assetprojects">
                                <Route index element={<AssetProjectsPage />} />
                                <Route path=":projectId" element={<AssetProjectPage />} />
                            </Route>
                            <Route path="client" element={<Client />} />
                            <Route path="deliveryConfigurations" element={<DeliveryConfiguration />} />
                            <Route path="materials" element={<Materials />} />
                            <Route path="models" element={<Models />} />
                            <Route path="modelpacks" element={<Modelpacks />} />
                            <Route path="bommodels">
                                <Route index element={<WhiteModels />} />
                                <Route path=":whiteModelId" element={<BomModels />} />
                            </Route>
                            <Route path="scenes" element={<Scenes />} />
                            <Route path="templates" element={<AdminTemplates />} />
                            <Route path="templatepresets" element={<TemplatePresets />} />
                            <Route path="modifiers" element={<Modifiers />} />
                            <Route path="damtransfers" element={<DAMTransfers />} />
                            <Route path="users" element={<Users />} />
                            <Route path="usergroups" element={<UserGroups />} />
                            <Route path="uiassetfiltergroups" element={<UIAssetFilterGroups />} />
                            {/* <Route path="uiassetfilters" element={<UIAssetFilters />} /> */}
                            <Route path="statistics" element={<StatisticsView />} />
                            <Route path="pages" element={<Pages />} />                           
                        </Route>
                    </Route>
                </Route>
            </Routes>);
    }, []);

    return routes;
};

export default AppRouter;
